import dayjs from "dayjs";

export const COLORS = [
  "#3f51b5",
  "#f50057",
  "#4caf50",
  "#ff9800",
  "#9c27b0",
  "#00bcd4",
  "#795548",
  "#607d8b",
];

export const FORECAST_COLOR = "#90a4ae";
export const SELECTED_BORDER = "#1976d2";
export const BAR_CHART_HEIGHT = 300;
export const LINE_CHART_HEIGHT = 300;
export const LINE_CHART_PADDING = { top: 30, right: 60, bottom: 40, left: 70 };

export function formatDollars(cents) {
  return (parseFloat(cents) / 100).toFixed(2);
}

export function currentMonthStr() {
  return dayjs().startOf("month").format("YYYY-MM-DD");
}

export function getCategoryCents(item, cat) {
  return parseFloat(item.byCategory?.[cat]?.totalCents) || 0;
}

export function getForecastCategoryCents(item, cat) {
  return parseFloat(item.forecast?.byCategory?.[cat]?.totalCents) || 0;
}

export function getEffectiveCategoryCents(item, cat) {
  return getCategoryCents(item, cat) + getForecastCategoryCents(item, cat);
}

export function getEffectiveCents(item) {
  const billed = parseFloat(item.totalCents) || 0;
  const forecast = parseFloat(item.forecast?.unbilledTotalCents) || 0;
  return billed + forecast;
}

export function stripCategoryPrefix(cat) {
  return cat.replace(/^partner_boom_report_/, "").replace(/_/g, " ");
}

export function getAllCategories(data) {
  const cats = new Set();
  data.forEach((item) => {
    Object.keys(item.byCategory || {}).forEach((c) => cats.add(c));
    Object.keys(item.forecast?.byCategory || {}).forEach((c) => cats.add(c));
  });
  return [...cats];
}
